<template>
  <div style="flex: 1">
    <Select2
      v-model="modalSchedule"
      :disabled="disabled"
      @change="onSelect"
      :options="options.data"
      :settings="{
        multiple: options.multiple || false,
        allowClear: options.allowClear || false,
      }"
    />
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";
import Select2 from "v-select2-component";

export default {
  directives: {
    ClickOutside,
  },
  components: {
    Select2,
  },

  props: {
    value: {
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (!this.options.all && val) {
        this.modalSchedule = val;
      } else {
        this.modalSchedule = val?.length
          ? val?.map((item) => item.id)
          : typeof(val) == "object" ? [val?.id] : [];
      }
    },
  },
  computed: {},
  data() {
    return {
      modalSchedule: null,
    };
  },

  mounted() {
    if (!this.options.all && this.value) {
      this.modalSchedule = this.value;
    } else {
      this.modalSchedule = this.value?.length
        ? this.value?.map((item) => item.id)
        : typeof(this.value) == "object" ? [this.value?.id] : [];
    }
  },

  methods: {
    onSelect(val) {
      if (this.options.multiple) {
        this.modalSchedule = [val.id, ...this.modalSchedule];
        const data = this.options.data.filter((item) =>
          this.modalSchedule.includes(item.id)
        );
        this.$emit("input", data);
      } else {
        this.$emit("input", val.id);
      }
    },
  },
};
</script>

<style lang="scss"></style>
